import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import moment from 'moment';
// components
import GraphHeader from 'components/series/tabbedGraphs/GraphHeader';
import SalesRevenueGraph from 'components/series/tabbedGraphs/SalesRevenueGraph';
import TicketSalesGraph from 'components/series/tabbedGraphs/TicketSalesGraph';
// import LoadingView from 'components/lib/messages/LoadingView';
import { NoSales } from 'components/lib/buttons/IconButtons';
import ErrorBoundary from 'components/lib/utils/ErrorBoundary';

//utils
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { DateFormatter } from 'utils/DateFormatter';
import { clone } from 'utils/utils';
import Constants from 'utils/Constants';

//styles
import theme from 'themes/theme';
import styles from 'styles/components/series/tabbedGraphs/tabbedGraphContainer.css';

class TabbedGraphContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartSize: {},
      revenueData: [],
      ticketsData: [],
      salesRevenueData: [],
      showDialog: false,
      hasTransactions: true,
      initialEndDate: null,
      initialStartDate: null
    };
  }
  componentWillReceiveProps(nProps) {
    if ( nProps.settings &&
      !Object.deepEquals(nProps.settings,this.props.settings)) {
      this.setState({
        initialEndDate: nProps.settings.initialEndDate,
        initialStartDate: nProps.settings.initialStartDate
      });
    }
    if (nProps.salesRevenue === 0) {
      this.setState({hasTransactions: false});
    } else {
      this.setState({hasTransactions: true});
    }
    if ( nProps.salesRevenueByDayData &&
      !Object.deepEquals(nProps.salesRevenueByDayData, this.props.salesRevenueByDayData)) {
    	this.getSalesData(nProps.salesRevenueByDayData);
    }
    if (nProps.ticketSalesByDayData &&
      !Object.deepEquals(nProps.ticketSalesByDayData, this.props.ticketSalesByDayData)) {
        this.getTicketsData(nProps.ticketSalesByDayData);
    }
  }
  getDateObject = (date) => {
    return date.toDateString().substring(4, 15);
  }
  getSalesData = (newSalesData) => { //console.log('GETSALESDATA');
    if (newSalesData) {
      this.setState({
        revenueData: Object.values(newSalesData)
      }, () => {
        this.props.onSettingChange({ hasSalesData: true });
      });
    }
  }
  getTicketsData = (newTicketData) => { // console.log('GETTICKETDATA');
    if(newTicketData) {
      let preparedTicketData = [];
      for (let keyDate of Object.keys(newTicketData)) {
        let newDate = DateFormatter.convertServerDate(keyDate, DateFormatter.GRAPH_DISPLAY)
        let labelObj = {label: newDate};
        let obj = Object.assign(newTicketData[keyDate], labelObj);
        preparedTicketData.push(obj);
      }

      this.setState({
        ticketsData: preparedTicketData,
        ticketSalesData: preparedTicketData.slice(preparedTicketData.length - 10)
      }, () => {
          this.props.onSettingChange({ hasTicketData: true });
      });
    }
  }
  handleChangeEndDate = (event, date) => { // console.log('HANDLE END');
    let { controlledStartDate } = this.props.settings;
    if (DateFormatter.isBefore(date, controlledStartDate)) this.toggleDialog();
    else   this.props.onSettingChange({ controlledEndDate: date });
  }
  handleChangeStartDate = (event, date) => {  // console.log('HANDLE START');
    let { settings, salesRevenueByDayData } = this.props;
    if (DateFormatter.isAfter(date, settings.controlledEndDate)) this.toggleDialog();
    else {
      let firstDataDate = new Date (salesRevenueByDayData[0].label);

      if (DateFormatter.isBefore(date, firstDataDate)) this.props.onRequestData(date, firstDataDate);
      else this.props.onSettingChange({ controlledStartDate: date });
    }
  }
  handleResetDates = () => { // console.log('HAND RESET');
      let { settings } = this.props;
      let { initialEndDate, initialStartDate } = this.state;
      if ( initialStartDate !== settings.controlledStartDate ||
          initialEndDate !== settings.controlledEndDate ) {
            this.props.onSettingChange({
              controlledEndDate: initialEndDate,
              controlledStartDate: initialStartDate,
              selectedUnit: Constants.unit.day });
      } else if (settings.selectedUnit !== Constants.unit.day){
        this.props.onSettingChange({ selectedUnit: Constants.unit.day });
      }
  }
  toggleDialog() {
    this.setState({ showDialog: !this.state.showDialog });
  }
  render() {
	  let { salesRevenue, salesRevenueGoal, selectedTabId, settings, ticketTypes, salesRevenueByDayData, chartSize } = this.props;
    let { controlledEndDate, controlledStartDate, selectedUnit } = settings;
    let { revenueData, ticketsData } = this.state;
    let isLoading = !(revenueData && ticketsData && controlledEndDate && controlledStartDate);
    // console.log(isLoading, !!revenueData, !!ticketsData, !!controlledEndDate, !!controlledStartDate);
    let salesPeriod =[];
    let ticketsPeriod = [];

    if (!isLoading) {
      if(ticketsData.length === 0) this.getTicketsData(this.props.ticketSalesByDayData);
      salesRevenueByDayData.forEach(function(date) {
        if (moment(date.label).isBetween(controlledStartDate, controlledEndDate, 'day', [])) {
          salesPeriod.push(clone(date));
        }
      });
      ticketsData.forEach(function(date){
        if (moment(date.label).isBetween(controlledStartDate, controlledEndDate, 'day', [])) {
          ticketsPeriod.push(clone(date));
        }
      });
      if (selectedUnit !== Constants.unit.day && ticketsPeriod.length > 1) {
        salesPeriod = DateFormatter.groupDatesForRevenue(selectedUnit, salesPeriod);
        ticketsPeriod = DateFormatter.groupDatesForTickets(selectedUnit, ticketsPeriod)
      }
    }
    const actions = [
      <FlatButton label="Okay" primary={true} onTouchTap={this.toggleDialog.bind(this)} />
    ];
    return (
      <MuiThemeProvider muiTheme={theme}>
        <div className={styles.tabbedGraphContainer}>
          <Dialog
            title="Invalid Date Range"
            actions={actions}
            modal={true}
            open={ this.state.showDialog } >
            You have selected an invalid date range. Please check and retry
          </Dialog>
          {this.state.hasTransactions &&
            <GraphHeader
              endValue={settings.controlledEndDate}
              formatDate={this.getDateObject}
              maxDate={settings.maxDate}
              minDate={settings.minDate}
              onStartChange={this.handleChangeStartDate}
              onEndChange={this.handleChangeEndDate}
              onTabChange={this.props.onTabChange}
              onUnitChange={(value) => this.props.onSettingChange({ selectedUnit: value })}
              onResetDates={this.handleResetDates}
              salesRevenue={!!settings.controlledEndDate ? salesRevenue : null}
              selectedUnit={settings.selectedUnit}
              selectedTab={ selectedTabId ? parseInt(selectedTabId, 10) : 0 }
              showDialog={this.state.showDialog}
              startValue={settings.controlledStartDate}
              toggleDialog={this.toggleDialog} />
          }
          <ErrorBoundary>
            <div ref="container" className={styles.graphContainer} >
             { this.state.hasTransactions ?
                ( !isLoading && salesPeriod && ticketsPeriod &&
                  <SwipeableViews
                    animateTransitions={true}
                    disabled={true}
                    index={selectedTabId ? parseInt(selectedTabId, 10) : 0}>
                      <SalesRevenueGraph
                        chartSize={chartSize}
                        selectedUnit={settings.selectedUnit}
                        salesRevenue={salesRevenue}
                        salesRevenueGoal={salesRevenueGoal}
                        data={salesPeriod} />
                      <TicketSalesGraph
                        chartSize={chartSize}
                        data={ticketsPeriod}
                        selectedUnit={settings.selectedUnit}
                        ticketTypes={ticketTypes} />
                   </SwipeableViews>
                )
               :  <NoSales />
            }
            </div>
          </ErrorBoundary>
        </div>
      </MuiThemeProvider>
    );
  }
}

TabbedGraphContainer.propTypes = {
  className: PropTypes.string,
  selectedTabId: PropTypes.number,
  salesRevenue: PropTypes.number,
  salesRevenueGoal: PropTypes.number,
  salesRevenueByDayData: PropTypes.array,
  onTabChange: PropTypes.func,
  ticketSalesByDayData: PropTypes.object,
  ticketTypes: PropTypes.array,
  seriesSummary: PropTypes.object,
}


export default TabbedGraphContainer;



// WEBPACK FOOTER //
// ./src/scripts/components/series/tabbedGraphs/TabbedGraphContainer.js